// extracted by mini-css-extract-plugin
export default {"detailContainer":"WalletDetailPage_detailContainer__oSDvs","detailImage":"WalletDetailPage_detailImage__r1CWB","detailDescription":"WalletDetailPage_detailDescription__RgiPm"};